import { Abbreviation } from 'app/model/cris/abbreviations';
import { Store } from 'app/model/cris/store';

import { RestfulApiService } from './restful-api.service';

class AbbreviationService extends RestfulApiService<Abbreviation, Store> {
    protected getFormName(): string {
        return 'abbreviation';
    }

    protected getPath(store: Store): string {
        if (!store.id) {
            throw new Error('Store ID is required for AbbreviationService');
        }

        return `stores/${store.id}/abbreviations`;
    }
}

export const abbreviationService = new AbbreviationService();
